/* papercrush Hilfeseiten
   - Inhaltsverzeichnis (schwebend auf Desktop)
   - Sprunglinks mit Abstand zum Header
   - Akkordeon oeffnet sich, wenn ein Link darauf zeigt
   - Ton-Knopf fuer Videos

   Stellschraube: KOPFABSTAND = Abstand zum oberen Rand beim Springen.
*/

(function () {
  var KOPFABSTAND = 120;

  window.__pcHilfe = window.__pcHilfe || {};
  var T = window.__pcHilfe;

  /* ---------- Hilfsfunktionen ---------- */

  function akkordeonOeffnen(ziel) {
    if (!ziel) return;
    var d = ziel.closest ? ziel.closest('details') : null;
    if (!d && ziel.tagName === 'DETAILS') { d = ziel; }
    while (d) {
      d.setAttribute('open', '');
      d = d.parentNode && d.parentNode.closest ? d.parentNode.closest('details') : null;
    }
  }

  function hinspringen(ziel) {
    if (!ziel) return;
    akkordeonOeffnen(ziel);
    window.requestAnimationFrame(function () {
      var y = ziel.getBoundingClientRect().top + window.pageYOffset - KOPFABSTAND;
      if (y < 0) { y = 0; }
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  function alleAkkordeonsSchliessen() {
    [].slice.call(document.querySelectorAll('details.pc-akkordeon[open]'))
      .forEach(function (d) { d.removeAttribute('open'); });
  }

  /* ---------- Alle Sprunglinks auf der Seite ---------- */

  function sprunglinks() {
    var bereich = document.querySelector('.rte') || document.body;
    var links = [].slice.call(bereich.querySelectorAll('a[href^="#"]'));

    links.forEach(function (link) {
      if (link.dataset.pcSprung) return;
      var ziel = link.getAttribute('href');
      if (!ziel || ziel === '#') return;
      link.dataset.pcSprung = 'ja';
      link.addEventListener('click', function (ev) {
        var el = document.querySelector(ziel);
        if (!el) return;
        ev.preventDefault();
        hinspringen(el);
        if (history.replaceState) { history.replaceState(null, '', ziel); }
      });
    });
  }

  /* ---------- Beim Laden mit Anker in der Adresse ---------- */

  function ankerBeimLaden() {
    if (!window.location.hash) return;
    var el = null;
    try { el = document.querySelector(window.location.hash); } catch (e) { return; }
    if (!el) return;
    setTimeout(function () { hinspringen(el); }, 200);
  }

  /* ---------- Ton-Knopf ---------- */

  function tonKnopf() {
    [].slice.call(document.querySelectorAll('.pc-video__ton')).forEach(function (knopf) {
      if (knopf.dataset.bereit) return;
      knopf.dataset.bereit = 'ja';
      var rahmen = knopf.closest('.pc-video__rahmen');
      var video = rahmen ? rahmen.querySelector('video') : null;
      if (!video) { knopf.style.display = 'none'; return; }
      knopf.addEventListener('click', function () {
        video.muted = !video.muted;
        knopf.textContent = video.muted ? 'Ton an' : 'Ton aus';
        if (!video.muted) { video.play(); }
      });
    });
  }

  /* ---------- Aufbau ---------- */

  function start() {
    alleAkkordeonsSchliessen();
    sprunglinks();
    tonKnopf();
    ankerBeimLaden();

    if (typeof T.aus === 'function') { T.aus(); T.aus = null; }

    var nav = document.querySelector('.pc-sprungmarken');
    if (!nav) return;

    var spalte = nav.closest('.rte') || nav.parentNode;
    var links = [].slice.call(nav.querySelectorAll('a'));
    if (!links.length) return;

    var eintraege = [];
    links.forEach(function (link) {
      var ziel = document.querySelector(link.getAttribute('href'));
      if (ziel) { eintraege.push({ link: link, ziel: ziel }); }
    });

    if (!eintraege.length) return;

    var anker = document.createComment('pc-toc');
    nav.parentNode.insertBefore(anker, nav);

    function platzieren() {
      if (window.innerWidth <= 1150) {
        if (nav.classList.contains('ist-schwebend')) {
          nav.classList.remove('ist-schwebend', 'ist-sichtbar');
          nav.style.left = '';
          anker.parentNode.insertBefore(nav, anker.nextSibling);
        }
        return;
      }

      var box = spalte.getBoundingClientRect();
      var x = box.left - 32 - 210;
      if (x < 16) return;

      if (!nav.classList.contains('ist-schwebend')) {
        document.body.appendChild(nav);
        nav.classList.add('ist-schwebend');
      }
      nav.style.left = x + 'px';
    }

    var wartet = false;
    function aktualisieren() {
      if (nav.classList.contains('ist-schwebend')) {
        var erst = eintraege[0].ziel.getBoundingClientRect();
        var letzt = eintraege[eintraege.length - 1].ziel.getBoundingClientRect();
        var drin = erst.top < window.innerHeight * 0.55 && letzt.bottom > 160;
        nav.classList.toggle('ist-sichtbar', drin);

        var aktiv = eintraege[0];
        eintraege.forEach(function (e) {
          if (e.ziel.getBoundingClientRect().top < 200) { aktiv = e; }
          e.link.classList.remove('ist-aktiv');
        });
        if (aktiv) { aktiv.link.classList.add('ist-aktiv'); }
      }
      wartet = false;
    }

    function anstossen() {
      if (!wartet) { wartet = true; requestAnimationFrame(aktualisieren); }
    }

    function beiResize() { platzieren(); aktualisieren(); }

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', beiResize);

    platzieren();
    aktualisieren();

    T.aus = function () {
      window.removeEventListener('scroll', anstossen);
      window.removeEventListener('resize', beiResize);
      if (nav.classList.contains('ist-schwebend') && anker.parentNode) {
        nav.classList.remove('ist-schwebend', 'ist-sichtbar');
        nav.style.left = '';
        anker.parentNode.insertBefore(nav, anker.nextSibling);
      }
    };
  }

  function neuAufbauen() { setTimeout(start, 80); }

  if (T.horcher) {
    document.removeEventListener('shopify:section:load', T.horcher);
  }
  T.horcher = neuAufbauen;
  document.addEventListener('shopify:section:load', T.horcher);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();